import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { useTable, useSortBy, useGlobalFilter } from "react-table";
import "bootstrap/dist/css/bootstrap.min.css";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import moment from "moment";
import Swal from "sweetalert2";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";


const PendingTransactionReport = () => {
  const [voucherType, setVoucherType] = useState(null);
  const [voucherData, setVoucherData] = useState([]);
  const pin = localStorage.getItem('pin');
const sewadarId=localStorage.getItem('sewadarId')

const exportToExcel = async () => {
  if (!voucherType || voucherData.length === 0) {
    Swal.fire("No Data", "Nothing to export", "warning");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet(voucherType.value);

  const columns = voucherColumns[voucherType.value];

  sheet.columns = columns.map((col, index) => ({
    header: col.Header,
    key: `col_${index}`,
    width: 22,
  }));

  sheet.getRow(1).font = { bold: true };
  sheet.getRow(1).alignment = { horizontal: "center" };

  voucherData.forEach((row) => {
    const excelRow = {};

    columns.forEach((col, index) => {
      let value = "";

      if (typeof col.accessor === "function") {
        value = col.accessor(row);
      } else {
        value = row[col.accessor];
    }

      // ✅ Date formatting
      if (
        value &&
        (col.Header.toLowerCase().includes("date"))
      ) {
        value = moment(value).isValid()
          ? moment(value).format("DD MMM YY")
          : value;
      }

      excelRow[`col_${index}`] = value ?? "";
    });

    sheet.addRow(excelRow);
  });

  sheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer]),
    `${voucherType.value}_Pending_${moment().format("DD-MM-YYYY")}.xlsx`
  );
};



const statusFieldMap = {
  "Receipt Voucher": "receiptStatus",
  "Delivery Challan": "isApproved",
  "Event Transaction": "voucherStatus",
  "Addition": "status",
  "Deduction": "status",
  "Gate Pass": "status",
  "Opening Stock": "status",
  "Location Transfer": "status",
  "Status Transfer": "status",
  "Unusable Production": "status",
  "Conversion": "status",
  "Project Requirement": "status",
  "Opening Stock Ledger": "status",
  "Addition Ledger": "status",
  "Deduction Ledger": "status",
};

  
  const voucherColumns = {
    "Receipt Voucher": [
      {
        Header: "Date",
        accessor: "entryDate",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      { Header: "RV No", accessor: "rvNo" },
      { Header: "Ledger Name", accessor: "ledgerName" },
      { Header: "Status", accessor: "receiptStatus" },
      {
        Header: "Created",
        accessor: row =>
          `${row.createdBySewadar?.firstName || ""} ${row.createdBySewadar?.lastName || ""}`
      },{
        Header: "Created At",
        accessor: row =>
          `${row.createdAt ? moment(row.createdAt).format('DD MMM YY hh:mm A'):''}`
      },
      
      
    ],

    "Addition": [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      { Header: "Ref No.", accessor: "draftCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Event", accessor: "purpose" },
      { Header: "Status", accessor: "status" },
      { Header: "Created", accessor: "createdBy" },
      {
        Header: "Created At",
        accessor: row =>
          `${row.created_at ? moment(row.created_at).format('DD MMM YY hh:mm A'):''}`
      },
    ],

    "Delivery Challan": [
      {
        Header: "Challan No",
        accessor: "refNo",
        Cell: ({ row }) => row.original.prefix + row.original.refNo,
      },
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      { Header: "Ledger", accessor: "ledger" },
      { Header: "Status", accessor: "isApproved" },
      { Header: "Created", accessor: "createdBy" },
    ],

    "Deduction": [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      { Header: "Ref No.", accessor: "draftCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Event", accessor: "purpose" },
      { Header: "Status", accessor: "status" },
      { Header: "Created", accessor: "createdBy" },
      {
        Header: "Created At",
        accessor: row =>
          `${row.created_at ? moment(row.created_at).format('DD MMM YY hh:mm A'):''}`
      },
    ],

    "Gate Pass": [
      {
        Header: "Date",
        accessor: "gatePassDate",
        Cell: ({ value }) => {
          if (!value) return "";
          const date = new Date(value);
          date.setHours(date.getHours() + 5);
          date.setMinutes(date.getMinutes() + 30);
          return moment(date).format("DD-MMM-YY");
        },
      },
      { Header: "GP Number", accessor: "gatePassCode" },
      { Header: "Vehicle Number", accessor: "vehicleNumber" },
      { Header: "Status", accessor: "status" },
      { Header: "Created", accessor: "createdBy" },
      {
        Header: "Created At",
        accessor: row =>
          `${row.createdAt ? moment(row.createdAt).format('DD MMM YY hh:mm A'):''}`
      },
    ],

    "Opening Stock": [
      {
        Header: "Date",
        accessor: "createdAt",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      { Header: "Ref No.", accessor: "openingStockNo" },
      { Header: "Department", accessor: "department" },
      { Header: "Status", accessor: "status" },
      { Header: "Created", accessor: "createdBy" },
      {
        Header: "Created At",
        accessor: row =>
          `${row.createdAt ? moment(row.createdAt).format('DD MMM YY hh:mm A'):''}`
      },
    ],

    "Location Transfer": [
      {
        Header: "Date",
        accessor: "transferDate",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      { Header: "Ref No.", accessor: "transferCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Status", accessor: "status" },
      { Header: "Created", accessor: "createdBy" },
      {
        Header: "Created At",
        accessor: row =>
          `${row.createdAt ? moment(row.createdAt).format('DD MMM YY hh:mm A'):''}`
      },
    ],

    "Status Transfer": [
      {
        Header: "Date",
        accessor: "transferDate",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      { Header: "Ref No.", accessor: "transferCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Location", accessor: "location" },
      { Header: "Status", accessor: "status" },
      { Header: "Created", accessor: "createdBy" },
      {
        Header: "Created At",
        accessor: row =>
          `${row.createdAt ? moment(row.createdAt).format('DD MMM YY hh:mm A'):''}`
      },    
    ],

    "Event Transaction": [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => moment(value).format("DD-MMM-YY"),
      },
      { Header: "Ref No.", accessor: "transactionCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Event", accessor: "event" },
      { Header: "Status", accessor: "voucherStatus" },
      {
        Header: "Created",
        accessor: row =>
          `${row.createdBySewadar?.firstName || ""} ${row.createdBySewadar?.lastName || ""}`
      },{
        Header: "Created At",
        accessor: row =>
          `${row.createdAt ? moment(row.createdAt).format('DD MMM YY hh:mm A'):''}`
      },
    ],

    "Unusable Production": [
      {
        Header: "Date",
        accessor: (row) => (row.date ? moment(row.date).format("DD-MMM-YY") : ""),
      },
      { Header: "Production No", accessor: "productionCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Status", accessor: "status" },
      {
        Header: "Created",
        accessor: row =>
          `${row.createdBySewadar?.firstName || ""} ${row.createdBySewadar?.lastName || ""}`
      },{
        Header: "Created At",
        accessor: row =>
          `${row.createdAt ? moment(row.createdAt).format('DD MMM YY hh:mm A'):''}`
      },
    ],

    "Conversion": [
      {
        Header: "Date",
        accessor: (row) =>
          row.createdAt ? moment(row.createdAt).format("DD-MMM-YY") : "",
      },
      { Header: "Conversion No", accessor: "conversionCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Status", accessor: "status" },
      {
        Header: "Created",
        accessor: row =>
          `${row.createdBySewadar?.firstName || ""} ${row.createdBySewadar?.lastName || ""}`
      },{
        Header: "Created At",
        accessor: row =>
          `${row.createdAt ? moment(row.createdAt).format('DD MMM YY hh:mm A'):''}`
      },
    ],

    "Project Requirement": [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => moment(value).format("DD-MMM-YY"),
      },
      { Header: "Ref No.", accessor: "requirementCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Status", accessor: "status" },
      {
        Header: "Created",
        accessor: row =>
          `${row.createdBySewadar?.firstName || ""} ${row.createdBySewadar?.lastName || ""}`
      },{
        Header: "Created At",
        accessor: row =>
          `${row.createdAt ? moment(row.createdAt).format('DD MMM YY hh:mm A'):''}`
      },
    ],

    "Opening Stock Ledger": [
      {
        Header: "Date",
        accessor: "createdAt",
        Cell: ({ value }) => moment(value).format("DD-MMM-YY"),
      },
      { Header: "Ref No.", accessor: "openingStockNo" },
      { Header: "Ledger", accessor: "ledgerName" },
      { Header: "Status", accessor: "status" },
      { Header: "Created", accessor: "createdBy" },
      {
        Header: "Created At",
        accessor: row =>
          `${row.createdAt ? moment(row.createdAt).format('DD MMM YY hh:mm A'):''}`
      },    
    ],

    "Addition Ledger": [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => moment(value).format("DD-MMM-YY"),
      },
      { Header: "Ref No.", accessor: "draftCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Event", accessor: "purpose" },
      { Header: "Status", accessor: "status" },
      { Header: "Created", accessor: "createdBy" },
      {
        Header: "Created At",
        accessor: row =>
          `${row.created_at ? moment(row.created_at).format('DD MMM YY hh:mm A'):''}`
      },
    ],

    "Deduction Ledger": [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => moment(value).format("DD-MMM-YY"),
      },
      { Header: "Ref No.", accessor: "draftCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Event", accessor: "purpose" },
      { Header: "Status", accessor: "status" },
      { Header: "Created", accessor: "createdBy" },
      {
        Header: "Created At",
        accessor: row =>
          `${row.created_at ? moment(row.created_at).format('DD MMM YY hh:mm A'):''}`
      },
    ],
  };

  

  const voucherOptions = Object.keys(voucherColumns).map((v) => ({
    label: v,
    value: v,
  }));

  const fetchVoucher = async (type) => {
    try {
      const res = await apiClient.post(SERVER_BASE + "/getPendingVoucherData", {
        voucherType: type,
      });

      setVoucherData(res.data.data || []);
    } catch (err) {
      console.error("Error fetching voucher:", err);
    }
  };
  const DataTable = ({ columns, data }) => {
    const memoCols = useMemo(() => columns, [columns]);
    const memoData = useMemo(() => data, [data]);

    const tableInstance = useTable(
      { columns: memoCols, data: memoData },
      useGlobalFilter,
      useSortBy
    );

    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
      state,
      setGlobalFilter,
    } = tableInstance;

    return (
      <>
    
    <div className="d-flex justify-content-between align-items-center mb-2">
                <input
            type="text"
    className="form-control w-50"
            placeholder="Search..."
            value={state.globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
          />

  <div className="d-flex gap-3 align-items-center">
            <strong>Showing {rows.length} records</strong>

    <button
      className="btn btn-success btn-sm"
      onClick={exportToExcel}
    >
      Export Excel
    </button>
  </div>
          </div>


        <table className="table table-bordered table-striped" {...getTableProps()}>
          <thead>
            {headerGroups.map((hg) => (
              <tr {...hg.getHeaderGroupProps()}>
                {hg.headers.map((col) => (
                  <th {...col.getHeaderProps(col.getSortByToggleProps())}>
                    {col.render("Header")}
                    {col.isSorted ? (col.isSortedDesc ? " 🔽" : " 🔼") : ""}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </>
    );
  };

  return (
    <div className="formcontainer mt-5">

      {/* HEADER + SELECT */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Voucher Pendencies</h5>

        <div style={{ width: "300px" }}>
          <Select
            options={voucherOptions}
            value={voucherType}
            placeholder="Select Voucher Type"
            onChange={(selected) => {
              setVoucherType(selected);
              fetchVoucher(selected.value);
            }}
          />
        </div>
      </div>

      {/* TABLE */}
      {voucherType && (
        <DataTable
          columns={voucherColumns[voucherType.value] || []}
          data={voucherData}
        />
      )}
    </div>
  );
};

export default PendingTransactionReport;
